import React from 'react';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import { RoutableRichText } from '../../react/RoutableRichText';
import css from './index.module.scss';

const Footer = ({ fields }) => (
  <footer className={css.container}>
    <div dangerouslySetInnerHTML={{__html: '<!-- BEGIN NOINDEX -->'}} />
    <div className={`${css.innerContainer} single-col-inner`}>
      <div className={css.mainContainer}>
        {
          (fields?.logo?.value?.src && fields?.logoLink?.value?.href) ?
            <RoutableLink field={fields.logoLink} className={css.logoContainer} title={null}>
              <Image field={fields.logo} className={css.logo} />
            </RoutableLink>
            :
            fields?.logo?.value?.src &&
            <div className={css.logoContainer}>
              <Image field={fields.logo} className={css.logo} />
            </div>
        }

        {
          (fields.addressTitle || fields.address) &&
          <div className={css.addressContainer}>
            <Text field={fields.addressTitle} tag='small' className={css.addressTitle} />
            <RoutableRichText field={fields.address} tag='address' className={css.address} />
          </div>
        }

        <ul className={css.linksContainer}>
          {
            fields.children?.map((links) => (
              links.fields?.children?.map((link, index) => (
                !link.fields?.socialIcon &&
                <li key={`footer-link-${index}`} className={css.linkListItem}>
                  <RoutableLink field={link.fields?.link} className={css.link} >
                    <Text field={link.fields?.linkText} />
                  </RoutableLink>
                </li>
              ))
            ))
          }
        </ul>

        <div className={css.socialContainer}>
          {
            fields.children?.map((links) => (
              links.fields?.children?.map((link, index) => (
                link.fields?.socialIcon &&
                <RoutableLink key={`footer-social-${index}`} field={link.fields?.link} className={css.socialIconLink} ariaLabel={`${link?.fields?.ARIALabelText?.value}`}>
                  <i className={`fa fa-${link.fields?.socialIcon.value.toLowerCase()} ${css.socialIcon}`} />
                </RoutableLink>
              ))
            ))
          }
        </div>
      </div>
      <div className={css.copyrightContainer}>
        <Text field={fields.copyRight} tag='small' className={css.copyright} />
      </div>
    </div>
    <div dangerouslySetInnerHTML={{__html: '<!-- END NOINDEX -->'}} />
  </footer>
);

export default Footer;